export const ColorsMenu = {
  admin: {
    text: '#0F5977',
    icon: '#0F5977', 
    background: '#DFECF9'
  },
  user: {
    text: '#3FB54B',
    icon: '#3FB54B',
    background: '#D9F0DB'
  }
}